var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36914 5.47461C5.36426 5.21582 5.27637 5.01074 5.06641 4.80566L1.38965 1.21191C1.2334 1.06055 1.05273 0.982422 0.828125 0.982422C0.378906 0.982422 0.0078125 1.34863 0.0078125 1.79297C0.0078125 2.01758 0.100586 2.22266 0.271484 2.39355L3.45508 5.46973L0.271484 8.55566C0.100586 8.72168 0.0078125 8.92676 0.0078125 9.15625C0.0078125 9.60059 0.378906 9.9668 0.828125 9.9668C1.04785 9.9668 1.2334 9.89355 1.38965 9.7373L5.06641 6.14355C5.27637 5.93848 5.36914 5.72852 5.36914 5.47461Z",
    fill: "#2E3A59",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.8e18e6d104f02d55ed948d1f891e5afc.svg";
export { ForwardRef as ReactComponent };